import ArticleSource from "@/api/ArticleSource.js";

export const articleModule = {
    state: () => ({
        isLoader: true,
        article: null,
    }),
    mutations: {},
    getters: {},
    actions: {
        async loadArticle({state, commit}, query) {
            state.isLoader = true;
            await this.$API.manager.getSource(ArticleSource).getArticleById(query).then((response) => {
                state.article = response;
                commit('setMetaTitleWithoutSub', response?.meta_title, {root: true})
                commit('setMetaRobots', 'index', {root: true})
                commit('setMetaDescription', response?.meta_description, {root: true})
            }).catch(() => {
                state.article = null;
            }).finally(() => {
                state.isLoader = false;
            })
        },
    },
    namespaced: true
}